
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Adverts",
      function () {
        return require("private-next-pages/Adverts/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Adverts"])
      });
    }
  